export default "__VITE_ASSET__D1Cty1GH__"